import React, {
  useCallback,
  useEffect,
  useState,
  ChangeEvent,
  Fragment,
} from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { RiCloseLine } from 'react-icons/ri';
import { FaRegTrashAlt } from 'react-icons/fa';

import { Button, IconButton, Input, TextField } from '@material-ui/core';
import Select from 'react-select';
import { AddCircleOutline } from '@material-ui/icons';
import DeliveryFee from '../../../../components/DeliveryFee';

import api from '../../../../services/api';
import empresaApi from '../../../../services/empresaApi';

import { useAuth } from '../../../../hooks/auth';
import { useToast } from '../../../../hooks/toast';

import {
  Wrapper,
  PageTitle,
  AddButton,
  FormWrapper,
  ModalWrapper,
  ButtonStyled,
  DividerStyled,
  InformativeSpan,
} from './styles';
import TaxaBairro from '../../../../components/TaxaBairro';
import slugfy from '../../../../utils/slugfy';
import deliveryFeesService from '../../../../services/DeliveryFeesService';
import importProducts from '../../../../services/importacaoDeProdutos';

interface QtdTaxas {
  index: number;
}

export interface TaxaEntrega {
  id?: number;
  valor: number;
  distancia: number;
  tempo_estimado_minuto: number;
  descricao: string;
  isNew: boolean;
  modalOpen: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      width: '70%',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #757575',
      borderRadius: '6px',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 0, 3),
    },
  }),
);

const ImportacaoProdutos: React.FC = () => {
  const { user } = useAuth();
  const { addToast } = useToast();
  const [selectedFile, setSelectedFile] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);

  const onFileChange = (event: any) => {
    setSelectedFile(event?.target?.files[0]);
  };

  const onFileUpload = async () => {
    setIsLoading(true);
    try {
      await importProducts(user.empresa_id, selectedFile);
      addToast({
        type: 'success',
        title: 'Importação realizada com sucesso!',
      });
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Houve um error ao realizar a importação',
      });
    }
    setIsLoading(false);

    setSelectedFile(null);
  };

  return (
    <Wrapper>
      <Grid
        container
        spacing={3}
        justify="center"
        alignItems="center"
        style={{ height: '100%' }}
      >
        <Grid item xs={12}>
          <PageTitle>Adicione novos produtos</PageTitle>
          <InformativeSpan>
            Selecione uma planilha com os produtos e grupos de produtos a serem
            cadastrados no atac delivery
          </InformativeSpan>
        </Grid>
        <Grid item style={{ marginTop: '30px' }}>
          <TextField
            disabled
            value={selectedFile?.name ?? 'Nenhum arquivo selecionado!'}
            style={{ marginRight: '10px' }}
          />
          <Button
            variant="contained"
            color="primary"
            component="label"
            startIcon={<AddCircleOutline />}
          >
            Adicionar planilha
            <input type="file" onChange={onFileChange} hidden />
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Grid container justify="center">
            <Grid item lg={4} md={6} xs={12}>
              <ButtonStyled
                disabled={isLoading}
                type="submit"
                onClick={onFileUpload}
              >
                {isLoading ? 'Importando' : 'Salvar'}
              </ButtonStyled>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default ImportacaoProdutos;
